
import { Component, Prop, VModel, Vue } from "vue-property-decorator";

import { ClaimReview, Partner } from "@/types";

import * as FactcheckServices from "@/services/FactCheckService";

@Component
export default class ClaimReviewForm extends Vue {
  @VModel() claimReview!: ClaimReview;
  @Prop() prefilledMetadata!: Record<string, {
    confidence: string;
    sourceQuote: string;
    originalUrl: string;
  }>;

  partners: Partner[] = [];

  async mounted() {
    this.partners = await FactcheckServices.GetPartners(true);
  }

  menu = false;
  activePicker = "";

  countries = [
    {
      name: "België",
      code: "BE",
    },
    {
      name: "Nederland",
      code: "NL",
    },
    {
      name: "Duitsland",
      code: "DE",
    },
  ];

  // Helper method to truncate quotes for display
  truncateQuote(quote: string, maxLength = 100): string {
    if (!quote || quote.length <= maxLength) {
      return quote;
    }
    return quote.substring(0, maxLength) + '...';
  }

  // Helper method to get color based on confidence level
  getConfidenceColor(confidence: string): string {
    switch (confidence.toLowerCase()) {
      case 'high':
        return 'success';
      case 'medium':
        return 'warning';
      case 'low':
        return 'error';
      default:
        return 'info';
    }
  }

  // Helper method to emit source quote data to parent
  openSourceQuote(fieldName: string) {
    if (this.prefilledMetadata && this.prefilledMetadata[fieldName]) {
      const metadata = this.prefilledMetadata[fieldName];
      this.$emit('open-source-quote', {
        url: metadata.originalUrl,
        text: metadata.sourceQuote
      });
    }
  }
}
